import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import 'src/mixins/chartjs';
import 'src/mixins/prismjs';
import {enableES5} from 'immer';
import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import * as serviceWorker from 'src/serviceWorker';
import {SettingsProvider} from 'src/context/SettingsContext';
import {restoreSettings} from 'src/utils/settings';
import App from 'src/App';
import {store} from './store';

enableES5();

const settings = restoreSettings();

ReactDOM.render(
    <Fragment>
        <Provider store={store}>
            <SettingsProvider settings={settings}>
                <App/>
            </SettingsProvider>
        </Provider>
    </Fragment>,
    document.getElementById('root'),
);

serviceWorker.unregister();
